// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notfound-main-container {
    position: fixed;
    top: 0;
    bottom:0;
    /* overflow-y:scroll; */
    overflow:hidden;
    width: 100%;
    height: 100svh;
    background-color: #ffffff;  
    display: flex;
    flex-direction: column;
    /* background-color: aqua; */
}

.notfound-container {
    display: flex;
    flex-direction: column;
    justify-content:center;
    width: 100%;
    /* z-index: -1; */
    padding: 5vw;
    /* background-color: red; */
}
@media (min-width: 640px) {
    .notfound-container{
        padding: 3vw;
    }
}
@media (min-width: 1024px) {
    .notfound-container{
        padding: 1.5vw;
    }
}

.four-zero {
    font-family: 'PPEiko';
    font-weight: normal;
    font-style: normal;
    font-size: 48vw;
    line-height: 32vw;
    color: #000000;
    /* background-color: aquamarine; */
    text-align: center;
}
@media (min-width: 640px) {
    .four-zero{
        font-size: 40vw;
        line-height: 32vw;
    }
}
@media (min-width: 1024px) {
    .four-zero{
        font-size: 30vw;
        line-height: 24vw;
    }
}

.four-zero-link {
    font-family: 'NeueHaasGrotesk';
    font-weight: normal;
    font-style: normal;
    font-size: 5vw;
    line-height: 5vw;
    color: #000000;
    text-align: center;
}
@media (min-width: 640px) {
    .four-zero-link{
        font-size: 3vw;
        line-height: 3vw;
    }
}
@media (min-width: 1024px) {
    .four-zero-link{
        font-size: 2vw;
        line-height: 2vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/NotFound/notfound.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,2BAA2B;AAC/B;AACA;IACI;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kCAAkC;IAClC,kBAAkB;AACtB;AACA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;AACJ;;AAEA;IACI,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;AACA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ","sourcesContent":[".notfound-main-container {\n    position: fixed;\n    top: 0;\n    bottom:0;\n    /* overflow-y:scroll; */\n    overflow:hidden;\n    width: 100%;\n    height: 100svh;\n    background-color: #ffffff;  \n    display: flex;\n    flex-direction: column;\n    /* background-color: aqua; */\n}\n\n.notfound-container {\n    display: flex;\n    flex-direction: column;\n    justify-content:center;\n    width: 100%;\n    /* z-index: -1; */\n    padding: 5vw;\n    /* background-color: red; */\n}\n@media (min-width: 640px) {\n    .notfound-container{\n        padding: 3vw;\n    }\n}\n@media (min-width: 1024px) {\n    .notfound-container{\n        padding: 1.5vw;\n    }\n}\n\n.four-zero {\n    font-family: 'PPEiko';\n    font-weight: normal;\n    font-style: normal;\n    font-size: 48vw;\n    line-height: 32vw;\n    color: #000000;\n    /* background-color: aquamarine; */\n    text-align: center;\n}\n@media (min-width: 640px) {\n    .four-zero{\n        font-size: 40vw;\n        line-height: 32vw;\n    }\n}\n@media (min-width: 1024px) {\n    .four-zero{\n        font-size: 30vw;\n        line-height: 24vw;\n    }\n}\n\n.four-zero-link {\n    font-family: 'NeueHaasGrotesk';\n    font-weight: normal;\n    font-style: normal;\n    font-size: 5vw;\n    line-height: 5vw;\n    color: #000000;\n    text-align: center;\n}\n@media (min-width: 640px) {\n    .four-zero-link{\n        font-size: 3vw;\n        line-height: 3vw;\n    }\n}\n@media (min-width: 1024px) {\n    .four-zero-link{\n        font-size: 2vw;\n        line-height: 2vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
